import { gql } from "graphql-tag";

export const GET_ANALYTICS_DEDUCTIONS_BY_TYPE_AND_REASON = gql`
  query AnalyticsDeductionsByTypeAndReason($params: GetAnalyticsInput!) {
    analyticsDeductionsByTypeAndReason(params: $params) {
      dimension
      rows {
        deductionType {
          id
          parentId
          deductionName
          deductionTypeKey
        }
        glCode {
          glCodeId
          glCode
          glCodeDescription
          displayName
        }
        amount
        count
        share
        vsPrior
        trend
      }
    }
  }
`;
